/* eslint-disable consistent-return */
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { get } from 'lodash';

export default () => (store) => {
  if (process.env.VUE_APP_S3D_STAGE === undefined
        || process.env.VUE_APP_VERSION === undefined) {
    console.warn('Datadog not enabled');
    return;
  }

  let logSessionSampleRate = 100;
  if (process.env.VUE_APP_DD_LOG_SESSION_SAMPLE !== undefined) {
    const envLogSessionSampleRate = parseInt(
      process.env.VUE_APP_DD_LOG_SESSION_SAMPLE,
      10,
    );
    logSessionSampleRate = Number.isNaN(envLogSessionSampleRate) || envLogSessionSampleRate == null
      ? logSessionSampleRate
      : envLogSessionSampleRate;
  }

  let rumSessionSampleRate = 20;
  if (process.env.VUE_APP_DD_RUM_SESSION_SAMPLE !== undefined) {
    const envSessionSampleRate = parseInt(
      process.env.VUE_APP_DD_RUM_SESSION_SAMPLE,
      10,
    );
    rumSessionSampleRate = Number.isNaN(envSessionSampleRate) || envSessionSampleRate == null
      ? rumSessionSampleRate
      : envSessionSampleRate;
  }

  let rumReplaySampleRate = 20;
  if (process.env.VUE_APP_DD_RUM_REPLAY_SAMPLE !== undefined) {
    const envReplaySampleRate = parseInt(
      process.env.VUE_APP_DD_RUM_REPLAY_SAMPLE,
      10,
    );
    rumReplaySampleRate = Number.isNaN(envReplaySampleRate) || envReplaySampleRate == null
      ? rumReplaySampleRate
      : envReplaySampleRate;
  }

  const commonDatadogConfig = {
    clientToken: 'pub7f596bf23d259647657ba3d60116277c',
    site: 'datadoghq.eu',
    service: 'recruitment',
    env: process.env.VUE_APP_S3D_STAGE,
    version: process.env.VUE_APP_VERSION,
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
  };

  datadogLogs.init({
    ...commonDatadogConfig,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    forwardReports: 'all',
    sessionSampleRate: logSessionSampleRate,
    telemetrySampleRate: 0,
  });

  datadogRum.init({
    ...commonDatadogConfig,
    applicationId: '39cae8e1-0628-41d9-9fc2-9784ad760dd6',
    sessionSampleRate: rumSessionSampleRate,
    sessionReplaySampleRate: rumReplaySampleRate,
    traceSampleRate: rumSessionSampleRate,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
    allowedTracingUrls: [/https:\/\/.*\.coactivecare\.co\.uk/],
  });

  // when user state changes update the datadog user properties
  return store.subscribe((mutation, state) => {
    if (mutation.type === 'auth/updateUser' || state.auth.authState === 'signedin') {
      datadogRum.setUserProperty('id', state.auth.user.id);
      if (state.auth.user.profile) {
        datadogRum.setUserProperty(
          'name',
          `${get(state.auth.user.profile, 'firstName').substring(0, 1).toUpperCase()}${get(state.auth.user.profile, 'lastName').substring(0, 1).toUpperCase()}`,
        );
      }
    }
    if (mutation.type === 'auth/changeAuthState' && state.auth.authState !== 'signedin') {
      datadogRum.stopSession();
      datadogRum.clearUser();
    }
  });
};
